import React from 'react';
import Text from 'reusecore/src/elements/Text';
import logoImg from '@core/ui/static/images/icon.png';
import Logo from '../../../components/Logo';
import SuccessModalWrapper, { LogoWrapper } from './style';
import Button from 'reusecore/src/elements/Button';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';

const signUpModalSuccess = ({ ...props }) => {
  const router = useRouter();
  const { t } = useTranslation();

  const { register } = props.user.data;
  return (
    <SuccessModalWrapper>
      <LogoWrapper>
        <Logo
          logoSrc={logoImg}
          title={t(`${process.env.APP_LOCALIZATION}:country.brand`) + ' Logo'}
        />
      </LogoWrapper>

      <Text
        content={t('signup.success.title')}
        as="span"
        fontSize={21}
        fontWeight={700}
        color="#333333"
        style={{ textAlign: 'center' }}
        mb={15}
      />

      {!register.isSpam ? (
        <Text
          content={t('signup.success.email')}
          as="span"
          fontSize={16}
          fontWeight={400}
          color="#8C8C8C"
          style={{ textAlign: 'center' }}
        />
      ) : (
        <div>
          <Text
            content={t('signup.success.email')}
            as="p"
            fontSize={16}
            fontWeight={400}
            color="#8C8C8C"
            style={{ textAlign: 'center' }}
          />
          <Text
            content={t(`${process.env.APP_LOCALIZATION}:register.spam.spam`)}
            as="p"
            fontSize={16}
            fontWeight={400}
            color="#8C8C8C"
            style={{ textAlign: 'center' }}
          />
        </div>
      )}

      {!register.isSpam && (
        <Button
          onClick={() => router.push('/signin')}
          title="Se Connecter"
          width={1}
          className={'primary'}
          loaderColor="#fff"
          mt={20}
        />
      )}
    </SuccessModalWrapper>
  );
};

export default signUpModalSuccess;
